var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMuted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7778 10.3977H15.8889C15.8889 11.1939 15.7111 11.9364 15.4111 12.6035L16.7778 13.9269C17.4 12.8725 17.7778 11.6781 17.7778 10.3977ZM13.3111 10.5806C13.3111 10.5161 13.3333 10.4623 13.3333 10.3977V3.94181C13.3333 2.15568 11.8444 0.713867 10 0.713867C8.15556 0.713867 6.66667 2.15568 6.66667 3.94181V4.13549L13.3111 10.5806ZM1.41111 1.78985L0 3.15635L6.67778 9.623V10.3977C6.67778 12.1838 8.15556 13.6257 10 13.6257C10.2444 13.6257 10.4889 13.5934 10.7222 13.5396L12.5667 15.3257C11.7778 15.6808 10.9 15.8852 10 15.8852C6.93333 15.8852 4.11111 13.6257 4.11111 10.3977H2.22222C2.22222 14.0668 5.24444 17.1011 8.88889 17.6283V21.1575H11.1111V17.6283C12.1222 17.4884 13.0778 17.1441 13.9333 16.6599L18.5889 21.1575L20 19.791L1.41111 1.78985Z",
    fill: "#5C5C5C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuted);
export default __webpack_public_path__ + "static/media/muted.19badbfc.svg";
export { ForwardRef as ReactComponent };